export function initGallery() {
  document.querySelectorAll('[data-gallery]').forEach((scroller) => {
    const root = scroller.closest('[data-gallery-root]') || scroller.parentElement;
    // Avanza una tarjeta (ancho + gap de 16px); si no hay tarjeta, 80% del viewport del carrusel
    const amount = () => {
      const card = scroller.querySelector('figure');
      return card ? card.getBoundingClientRect().width + 16 : scroller.clientWidth * 0.8;
    };
    root.querySelector('[data-gallery-prev]')?.addEventListener('click', () =>
      scroller.scrollBy({ left: -amount(), behavior: 'smooth' }));
    root.querySelector('[data-gallery-next]')?.addEventListener('click', () =>
      scroller.scrollBy({ left: amount(), behavior: 'smooth' }));
  });
}
